import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { purpurColorFunctionalWhite } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
const StyledPaper = styled.div `
  background-color: ${purpurColorFunctionalWhite};
  border-radius: ${pxToRem(5)};
  color: 'inherit';
  flex-shrink: 0;
  overflow: hidden;
  padding: ${props => props.$padding};
  position: relative;

  @media (max-height: 420px) and (orientation: landscape) {
    max-height: 360px;
  }
`;
export const Paper = ({ children, padding = spacing.spacing24 }) => (_jsx(StyledPaper, { "$padding": padding, children: children }));
